import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { SubjectDatabase } from './subjectDatabase';
import { Subject } from '../../../../models/subjects/subject';

export class SubjectDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    filteredData: Subject[] = [];
    renderedData: Subject[] = [];
    dataLength = 0;

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    constructor(
        private _subjectDatabase: SubjectDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<Subject[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._subjectDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._subjectDatabase.data.slice().filter((item: Subject) => {
                const searchStr = (item.Name).toLowerCase();
                return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._subjectDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: Subject[]): Subject[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }
        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'Name':
                    [propertyA, propertyB] = [a.Name, b.Name];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/subjectDataSource.ts